/* eslint-disable prettier/prettier */
import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: '', // e.g: 'Name | Developer'
  lang: 'en', // e.g: en, es, fr, jp
  description: 'Welcome to D. Zagorsky website', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: '',
  name: 'Dmitry',
  subtitle: "I'm a Web developer",
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: '',
  paragraphOne: 'Welcome! I am Dmitry Zagorsky, a self-taught front-end developer from Russia who enjoys writing web applications with React.',
  paragraphTwo: 'In the future I\'d love to learn more about programming in C#, or maybe try myself at C/C++. I\'m all for a "need to learn" approach - should the project I will be working on require learning something new, I won\'t hesitate to pick it up.',
  paragraphThree: 'My key skills are:',
  resumeRu: 'https://www.resumemaker.online/es.php', // if no resume, the button will not show up
  resumeEn: 'https://www.resumemaker.online/en.php',
  keySkills: ['React(with Hooks)', 'JavaScript(ES6+/TypeScript)', 'Redux', 'HTML5', 'CSS3', 'Node.js', 'PostgreSQL', 'Git version control', 'npm'],
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'swapiapp.jpg',
    title: 'SWAPIApp',
    info: 'A React app that fetches and displays data from a REST API(SWAPI).',
    info2: 'Data is split into categories, with pagination and search functionality.',
    url: 'https://kykuy.github.io/SWAPI-app/',
    repo: 'https://github.com/Kykuy/SWAPI-app', // if no repo, the button will not show up
  },  
  {
    id: nanoid(),
    img: 'ancient_viewer.jpg',
    title: 'Inquisitor - Martyr: Ancient Relic Viewer',
    info: 'A React app that fetches datamined data for a videogame from a Google spreadsheet via an open-source library.',
    info2: 'The result is an interface that allows the user to select a combination of item type/enchantment and see full info for each item combination',
    url: 'https://40k-ancient-viewer.netlify.app/',
    repo: 'https://github.com/Kykuy/40k-ancient-viewer', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'ancient_list.jpg',
    title: 'Inquisitor - Martyr: Ancient Relic List',
    info: 'A pure HTML/CSS/JS app that parses and visualises datamined data for a videogame from a .txt file.',
    info2: '',
    url: 'https://40k-inquisitor-ancient-list.netlify.app/',
    repo: 'https://github.com/Kykuy/40K-ancient-list', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'landing.jpg',
    title: 'Pizza Landing',
    info: 'A pure HTML/CSS landing page mockup.',
    info2: 'Fully responsive.',
    url: 'https://kykuy.github.io/Adaptive_landing/',
    repo: 'https://github.com/Kykuy/Adaptive_landing', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: '',
  email: 'dzag0285@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [   
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/Kykuy',
    }, 
    // {
    //   id: nanoid(),
    //   name: 'linkedin',
    //   url: '',
    // },
    {
      id: nanoid(),
      name: 'telegram',
      url: 'https://t.me/Kykuy',
    },    
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
